import DocumentComponent from "../DocumentComponent.vue";

export default [
    {
        path: '/documents',
        name: 'Document',
        meta: { layout: 'default' },
        component: DocumentComponent,
    },
]